// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import "../src/less/root.less"
import {
  createStore
} from './store'
import 'amfe-flexible/index.js'
import 'vant/lib/index.css'

import '../src/less/flex.css';
import Vant from 'vant'
Vue.use(Vant)

Vue.config.productionTip = false
const store = createStore()

import axios from 'axios'
// import vconsole from "vconsole";
import eruda from "eruda";
if (
  location.host.indexOf("localhost") > -1 ||
  location.origin == "http://csh-test.chinaubi.cn"
) {
  eruda.init()
}

import {
  reqPos,
  reqGet,
  reqPosFor,
  reqPosFor2
} from './request/http';
Vue.prototype.reqPos = reqPos;
Vue.prototype.reqGet = reqGet;
Vue.prototype.reqPosFor = reqPosFor;
Vue.prototype.reqPosFor2 = reqPosFor2;
Vue.prototype.axios = axios

Vue.config.productionTip = false
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

//添加路由后置钩子
router.afterEach((to, from) => {
  try {
    let style = {
      text: '', //标题
      color: '', //文字颜色
      image: ''
    }
    UNIApp.setNavTitle(to.meta.title, style, '')
  } catch (error) {}

})

router.beforeEach((to, from, next) => {
  if (to.path === '/ConfirmPrice' && from.path === '/myorder' && sessionStorage.getItem('orderToConfirmPrice') !== 'true') {

    next({
      path: '/'
    })
  } else {
    next()
  }

})
window.appOnload = function () {}



// WEBPACK FOOTER //
// ./src/main.js